import { API, BASE_URL } from './config';

export default {
    getAllUsers: async () => {
        try {
            const response = await API.get(`${BASE_URL}/webapi/user/list`);
            // console.log('response', response.data)
            return response;
        } catch (error) {
            console.log('error', error)
            return error.response;
        }
    },

    createUser: async (reqBody) => {
        try {
            const response = await API.post(`${BASE_URL}/webapi/user/create`, reqBody);
            return response;
        } catch (error) {
            console.log('err', error)
            return error.response;
        }
    },

    deleteUserById: async (reqBody) => {
        try {
            const response = await API.post(`${BASE_URL}/webapi/user/delete`, reqBody);
            return response;
        } catch (error) {
            return error.response
        }
    },

    updateUserById: async (id, reqBody) => {
        try {
            const response = await API.post(`${BASE_URL}/webapi/user/update/${id}`, reqBody);
            return response;
        } catch (error) {
            console.log("error", error)
            return error.response
        }
    },

    getAllUsersLocation: async () => {
        try {
            const response = await API.get(`${BASE_URL}/api/user-location/638850d17f673cad321aa999`);
            console.log('response', response.data)
            return response;
        } catch (error) {
            console.log('error', error)
            return error.response;
        }
    },

    downloadFile: async (reqBody) => {
        try {
            const response = await API.post(`${BASE_URL}/api/download`, { responseType: 'blob' }, reqBody);
            return response;
        } catch (error) {
            console.log("error", error)
            return error.response
        }
    },
    dashboardCounting: async () => {
        try {
            const response = await API.get(`${BASE_URL}/webapi/dashboard-counting`);
            // console.log('response', response.data)
            return response;
        } catch (error) {
            console.log('error', error)
            return error.response;
        }
    },

    getUserInfo: async (id) => {
        try {
            const response = await API.get(`${BASE_URL}/webapi/user-details/${id}`);
            // console.log('response', response.data)
            return response;
        } catch (error) {
            console.log('error', error)
            return error.response;
        }
    },

    // webapi/dashboard-counting
}